var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 7.83521H9.79163V35.2519C9.79163 36.2906 10.2043 37.2869 10.9388 38.0214C11.6733 38.7559 12.6695 39.1685 13.7083 39.1685H29.375M31.3333 29.3769L37.2083 23.5019M37.2083 23.5019L31.3333 17.6269M37.2083 23.5019H17.625",
    stroke: "#1731AC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitBlue);
export default __webpack_public_path__ + "static/media/exit-blue.5fbf8b23d0b642949d1e38c31af057bd.svg";
export { ForwardRef as ReactComponent };